(function () {
  'use strict';

  var config = document.currentScript;
  var scriptUrl = config && config.dataset.quickViewScript;
  var styleUrl = config && config.dataset.quickViewStyle;
  var loading = null;
  var loaded = false;

  function loadQuickView() {
    if (loading) return loading;

    loading = new Promise(function (resolve, reject) {
      var remaining = 2;
      var failed = false;

      function complete() {
        remaining -= 1;
        if (remaining === 0 && !failed) {
          loaded = true;
          resolve();
        }
      }

      function fail() {
        if (failed) return;
        failed = true;
        reject(new Error('Quick view asset failed to load'));
      }

      var stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = styleUrl;
      stylesheet.onload = complete;
      stylesheet.onerror = fail;
      document.head.appendChild(stylesheet);

      var script = document.createElement('script');
      script.src = scriptUrl;
      script.onload = complete;
      script.onerror = fail;
      document.head.appendChild(script);
    });

    return loading;
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.target.closest && event.target.closest('[data-quick-view]')) loadQuickView();
  }, { capture: true, passive: true });

  document.addEventListener('focusin', function (event) {
    if (event.target.closest && event.target.closest('[data-quick-view]')) loadQuickView();
  }, true);

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-quick-view]');
    if (!trigger || loaded) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    loadQuickView().then(function () {
      trigger.click();
    }, function () {
      window.location.assign(trigger.href);
    });
  }, true);
})();
